import { RadialBar, RadialBarChart, ResponsiveContainer, Tooltip } from "recharts"
import { AnalysisCampaignObject, CampaignObject } from "../../../../types/APITypes";
import { useColor } from '@braze/beacon-styling';

interface ModalPieChartProps {
    campaign: AnalysisCampaignObject;
}

export const ModalPieChart = ((props: ModalPieChartProps) => {
    const colorGetter = useColor()

    const data = [
        {
            name: "Pipe #",
            count: props.campaign.pipe_count,
            fill: colorGetter("orange", 400),
          },
        {
            name: "SQLs",
            count: props.campaign.sql_count,
            fill: colorGetter("red", 400),
          },
        {
            name: 'MQLs',
            count: props.campaign.mql_count,
            fill: colorGetter("lightGreen", 400),
          },
          {
            name: "NNLs",
            count: props.campaign.nnl_count,
            fill: colorGetter("lightBlue", 400),
          },
          
          
      ];
    return (
        <>
            <ResponsiveContainer  width="100%" height="100%">
                <RadialBarChart innerRadius="30%" outerRadius="80%" barSize={30} 
                barCategoryGap={20}                
                data={data}>
                    <RadialBar
                        minPointSize={25}
                        label={{ position: 'insideStart', fill: "#fff" }}
                        dataKey="count"
                    />
                    <Tooltip labelFormatter={(label, payload) => {
                        return data[label]["name"]}}/>
                </RadialBarChart>
            </ResponsiveContainer>
        </>
    )
})